<template>
    <b-modal ref="modal" :centered="data.centered || false" :no-close-on-backdrop="data.noCloseOnBackdrop || false" :no-close-on-esc="data.noCloseOnEsc || false" :ok-only="true" :ok-title="_trans('Ok')" :scrollable="data.scrollable || false" :size="data.size || 'md'" :title-html="_trans('Assign project')" @hidden="onClose" @hide="hide" @ok="close(1)" @shown="onShow">
        <div class="my-4 d-flex flex-column">
            <circle-loader v-if="!shops || (toShop && !users)" class="mx-auto"></circle-loader>
            <div v-if="shops && filters.showInputShop">
                <h6><span v-text="_trans('Shop:')"></span>&nbsp;<span v-if="toShop" class="text-primary" v-text="toShop.des"></span></h6>
                <shop-search v-model="toShop" :data="shops" :placeholder="_trans('Search shop')">
                    <div slot="item" slot-scope="props" class="single-item">
                        <span v-if="showShopsCod" v-text="props.item.cod"></span>
                        <span v-if="showShopsCod">-</span>
                        <span v-text="props.item.des"></span>
                    </div>
                </shop-search>
            </div>

            <div v-if="toShop && users" class="mt-3">
                <h6><span v-text="_trans('User:')"></span>&nbsp;<span v-if="toUser" class="text-primary" v-text="toUser.des"></span></h6>
                <shop-search v-model="toUser" :data="users" :placeholder="_trans('Search user')">
                    <div slot="item" slot-scope="props" class="single-item">
                        <span v-if="showUsersCod" v-text="props.item.cod"></span>
                        <span v-if="showUsersCod">-</span>
                        <span v-text="props.item.des"></span>
                        <!--<span v-text="props.item.email"></span>-->
                        <!--<pre>{{ props.item }}</pre>-->
                    </div>
                </shop-search>
            </div>
        </div>

        <div slot="modal-footer">
            <b-button variant="default" @click="close(0)" v-text="_trans('Cancel')"></b-button>
            <b-button :disabled="!toShop || !toUser" variant="primary" @click="confirm()" v-text="lblAssign"></b-button>
        </div>
    </b-modal>
</template>
<script>
    import { customImport } from "@/utils";
    import { NextApiClient } from "@3cad/nextcore";
    import modal from "@dialogs/modal.vue";

    export default {
        mixins: [modal],
        components: {
            circleLoader: () => customImport("comp/circleLoader.vue"),
            sqrLoader: () => customImport("comp/sqrLoader.vue"),
            shopSearch: () => customImport("comp/shopSearch.vue")
        },
        props: {
            showShopsCod: { type: Boolean, default: true },
            showUsersCod: { type: Boolean, default: true }
        },
        data() {
            return {
                toShop: null,
                toUser: null,
                shops: [],
                users: [],
                filters: {
                    currentUser: 0,
                    showInputShop: true,
                    shop: false,
                    validShops: [],
                    userLevel: false,
                    validUsersLevel: [],
                    toOrder: false,
                    agency: null
                },
                lblAssign: ""
            };
        },
        computed: {
            preferences() {
                return this.$store.getters["getPreferences"];
            }
        },
        watch: {
            toShop(newVal) {
                const _this = this;
                if (newVal) {
                    NextApiClient.com(
                        "projects",
                        "jGetUsers",
                        { shop: newVal.cod },
                        json => {
                            if (!json) throw "Wrong data";
                            if (_this.filters.userLevel) {
                                if (_this.filters.agency && newVal.cod === _this.filters.agency) {
                                    _this.filters.validUsersLevel = [3];
                                }
                                _this.users = json.filter(el => {
                                    return _this.filters.validUsersLevel.inArray(e => {
                                        return el.cod !== this.filters.currentUser && e === el.seller;
                                    });
                                });
                            } else {
                                _this.users = json.filter(el => {
                                    return el.cod !== this.filters.currentUser;
                                });
                            }
                        },
                        err => {
                            throw err;
                        }
                    );
                }
            }
        },
        methods: {
            onShow() {
                // this.data.projectId -> id progetto
                if (this.data.conditions) {
                    this.filters = this.data.conditions;
                }

                if (this.filters.toOrder) {
                    this.lblAssign = this._trans("Order");
                } else {
                    this.lblAssign = this._trans("Assign");
                }

                this.toShop = null;
                this.toUser = null;
                this.shops = [];
                this.users = [];

                NextApiClient.com(
                    "projects",
                    "jGetShops",
                    {},
                    json => {
                        if (!json) throw "Wrong data";
                        if (this.filters.shop) {
                            this.shops = json.filter(el => {
                                return this.filters.validShops.inArray(e => {
                                    return e.toLowerCase() === el.cod.toLowerCase();
                                });
                            });
                        } else {
                            this.shops = json;
                        }
                        if (this.shops.length === 1) {
                            this.filters.showInputShop = false;
                            this.toShop = this.shops[0];
                        }
                    },
                    err => {
                        throw err;
                    }
                );
            },
            confirm() {
                this.response.shop = this.toShop.cod;
                this.response.user = this.toUser.cod;
                this.response.userMail = this.toUser.email;
                this.close(1);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/custom/progeo/dialogs/modalAssign.vue